import script from "./AtomEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomEditView.vue?vue&type=script&setup=true&lang=js"

import "./AtomEditView.vue?vue&type=style&index=0&id=397d8364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397d8364"]])

export default __exports__